import ApiClient from "shared/service/api/ApiClient";
import {
    Client,
    PeriodType,
    ScorecardReportV3Filter_Public,
    ScorecardReportV3Filter_PublicLevel,
    ScorecardV3_Public,
} from "shared/service/api/generated";
import { ScorecardReport } from "./api/models";
import _ from "lodash";

class ScoresService {
    private apiClient: Client;

    constructor(apiClient: Client) {
        this.apiClient = apiClient;
    }

    async getPeriods(periodType: PeriodType): Promise<ScorecardV3_Public[]> {
        const apiResponse = await this.apiClient.scorecard_v3_periodList(periodType, undefined);
        return _.orderBy(apiResponse, (p) => p.endDate, "desc");
    }

    async getScoreCardReport(
        level?: ScorecardReportV3Filter_PublicLevel,
        scorecardToken?: string
    ): Promise<ScorecardReport> {
        const body = new ScorecardReportV3Filter_Public({
            level: level,
            scorecardToken: scorecardToken,
        });

        const report = await this.apiClient.scorecard_v3_getReport(body);
        return new ScorecardReport(report);
    }
}

export default new ScoresService(ApiClient);
